import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthContext } from '@myphx-engineering/auth/client';
import { useNavBar } from '@myphx-engineering/phx-design-system';

import { DrugSearch } from '../../components/drug-search/DrugSearch';
import { useFlags } from '../../hooks/use-flags';
import { getAbsoluteRoute } from '../../util';

import { DrugSearchRouteV2 } from './DrugSearchRouteV2';

export const DrugSearchRoute = () => {
    const { typeaheadSearchEnabled } = useFlags();

    if (typeaheadSearchEnabled) {
        return <DrugSearchRouteV2 />;
    }

    return <DrugSearchRouteV1 />;
};

const DrugSearchRouteV1 = () => {
    const { setBackOverrideState } = useNavBar();
    const { isAuthenticated } = useAuthContext();

    const navigate = useNavigate();
    const onDrugSelect = (drugId: string, searchParams?: string) => {
        //@TODO: Telemetry
        const path = getAbsoluteRoute('drug.drugId.root', { drugId });
        navigate({
            pathname: path,
            search: searchParams ?? '',
        });
    };

    const handleBack = useCallback(() => {
        if (isAuthenticated) {
            navigate(getAbsoluteRoute('home'));
        } else {
            navigate(getAbsoluteRoute('root'));
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        setBackOverrideState({
            overrideFn: handleBack,
        });

        return () => setBackOverrideState({ overrideFn: null });
    }, [handleBack, setBackOverrideState]);

    return <DrugSearch shouldAutoFocus onDrugSelect={onDrugSelect} />;
};
